import { render, staticRenderFns } from "./card.vue?vue&type=template&id=1b037e75&scoped=true"
import script from "./card.vue?vue&type=script&lang=js"
export * from "./card.vue?vue&type=script&lang=js"
import style0 from "./card.vue?vue&type=style&index=0&id=1b037e75&prod&scoped=true&lang=css"
import style1 from "./card.vue?vue&type=style&index=1&id=1b037e75&prod&lang=css"
import style2 from "./card.vue?vue&type=style&index=2&id=1b037e75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b037e75",
  null
  
)

export default component.exports